import { render, staticRenderFns } from "./ListBadge.vue?vue&type=template&id=622cf364&scoped=true&lang=pug&"
import script from "./ListBadge.vue?vue&type=script&lang=ts&"
export * from "./ListBadge.vue?vue&type=script&lang=ts&"
import style0 from "./ListBadge.vue?vue&type=style&index=0&id=622cf364&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622cf364",
  null
  
)

export default component.exports